'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    width: 100%;\n'], ['\n    width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    overflow: hidden;\n\n    /* max-width: 345px;\n\n    @media (min-width: ', ') {\n      max-width: 460px;\n    }\n\n    @media (min-width: ', ') {\n      max-width: 750px;\n    }\n\n    @media (min-width: ', ') {\n      max-width: 940px;\n    } */\n    width: 100%;\n\n    max-height: ', ';\n'], ['\n    overflow: hidden;\n\n    /* max-width: 345px;\n\n    @media (min-width: ', ') {\n      max-width: 460px;\n    }\n\n    @media (min-width: ', ') {\n      max-width: 750px;\n    }\n\n    @media (min-width: ', ') {\n      max-width: 940px;\n    } */\n    width: 100%;\n\n    max-height: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    padding: 20px;\n'], ['\n    padding: 20px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n    flex-wrap: none;\n    width: 100%;\n    overflow: hidden;\n'], ['\n    display: flex;\n    flex-wrap: none;\n    width: 100%;\n    overflow: hidden;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    float: left;\n    margin-left: ', '%;\n    height: 100%;\n    width: 100%;\n    text-align: center;\n    z-index: ', ';\n    opacity: ', ';\n    transform: ', ';\n    transition: opacity 1s;\n'], ['\n    float: left;\n    margin-left: ', '%;\n    height: 100%;\n    width: 100%;\n    text-align: center;\n    z-index: ', ';\n    opacity: ', ';\n    transform: ', ';\n    transition: opacity 1s;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    width: ', ';\n    height: ', ';\n    opacity: ', ';\n    transition: opacity 1s;\n'], ['\n    width: ', ';\n    height: ', ';\n    opacity: ', ';\n    transition: opacity 1s;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    width: 100%;\n    text-align: center;\n    padding: 1rem;\n'], ['\n    width: 100%;\n    text-align: center;\n    padding: 1rem;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _alignments = require('../../constants/alignments');

var _colors = require('../../constants/colors');

var _screenSize = require('../../constants/screenSize');

var _sizes = require('../../constants/sizes');

var _carouselButton = require('../../atoms/buttons/carouselButton');

var _carouselButton2 = _interopRequireDefault(_carouselButton);

var _header = require('../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _isMobile = require('../../helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var CarouselComponent = _styledComponents2.default.div(_templateObject2, _screenSize.ScreenSize.sm, _screenSize.ScreenSize.md, _screenSize.ScreenSize.lg, function (_ref) {
    var visible = _ref.visible;
    return visible ? '1500px' : '0px';
});

var CarouselButtonComponent = _styledComponents2.default.div(_templateObject3);

var ItemsComponent = _styledComponents2.default.div(_templateObject4);

var ItemComponent = _styledComponents2.default.div(_templateObject5, function (_ref2) {
    var index = _ref2.index;
    return index > 0 ? -100 : 0;
}, function (_ref3) {
    var visible = _ref3.visible;
    return visible ? 1 : -1;
}, function (_ref4) {
    var visible = _ref4.visible;
    return visible ? 1 : 0;
}, function (_ref5) {
    var visible = _ref5.visible;
    return visible ? 'scaleY(1)' : 'scaleY(0)';
});

var NoItemsComponent = _styledComponents2.default.div(_templateObject6, function (_ref6) {
    var visible = _ref6.visible;
    return visible ? '100%' : '0px';
}, function (_ref7) {
    var visible = _ref7.visible;
    return visible ? '220px' : '0px';
}, function (_ref8) {
    var visible = _ref8.visible;
    return visible ? 1 : 0;
});

var NoItemsContentComponent = _styledComponents2.default.div(_templateObject7);

var Carousel = function (_React$Component) {
    _inherits(Carousel, _React$Component);

    function Carousel(props) {
        _classCallCheck(this, Carousel);

        var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

        _this.handleTouchStart = function (e) {
            var touch = e.changedTouches[0];

            _this.setState({ startX: touch.pageX });
            _this.setState({ startY: touch.pageY });
        };

        _this.handleTouchEnd = function (e) {

            var node = _reactDom2.default.findDOMNode(_this);

            var nodePosition = node.getBoundingClientRect();

            var touch = e.changedTouches[0];

            var startedInside = _this.state.startX >= nodePosition.left && _this.state.startX <= nodePosition.right && _this.state.startY >= nodePosition.top && _this.state.startY <= nodePosition.bottom;

            var finishedInside = touch.pageX >= nodePosition.left && touch.pageX <= nodePosition.right && touch.pageY >= nodePosition.top && touch.pageY <= nodePosition.bottom;

            if (_this.props.orientation === "vertical") {
                var swipe = Math.abs(_this.state.startY - touch.pageY) > 25;

                if (swipe && startedInside && finishedInside) {
                    _this.handleCarousel(_this.state.startY - touch.pageY < 0 ? "down" : "up");
                }
            } else {
                var _swipe = Math.abs(_this.state.startX - touch.pageX) > 25;

                if (_swipe && startedInside && finishedInside) {
                    _this.handleCarousel(_this.state.startX - touch.pageX > 0 ? "right" : "left");
                }
            }
        };

        _this.state = {
            showNoItems: true,
            items: true,
            hadItems: false,
            direction: "",
            currentItem: 0,
            currentItemKey: "",
            startX: 0,
            startY: 0
        };
        return _this;
    }

    _createClass(Carousel, [{
        key: 'handleCarousel',
        value: function handleCarousel(direction) {
            this.setState({ previousItem: this.state.currentItem });

            if (direction === "right" || direction === "down") {
                if (this.state.currentItem === this.props.items.length - 1) {
                    this.setState({ currentItem: 0 });
                } else {
                    this.setState({ currentItem: this.state.currentItem + 1 });
                }
            } else if (direction === "left" || direction === "up") {
                if (this.state.currentItem === 0) {
                    this.setState({ currentItem: this.props.items.length - 1 });
                } else {
                    this.setState({ currentItem: this.state.currentItem - 1 });
                }
            }

            this.setState({ direction: direction });
        }
    }, {
        key: 'toggleNoComponentsMessage',
        value: function toggleNoComponentsMessage() {
            var _this2 = this;

            if (this.props.items) {

                if (this.props.items.length > 0) {
                    if (this.state.hadItems === false) {
                        this.setState({ hadItems: true });
                    }
                }

                if (this.state.currentItem !== 0 && this.props.items.length !== 0) {
                    if (this.state.currentItem >= this.props.items.length) {
                        this.setState({ currentItem: this.props.items.length - 1 });
                    }
                }
            }

            if (this.props.items === null || this.props.items.length === 0) {
                if (this.state.items) {
                    this.setState({ items: false });
                }
                if (this.state.showNoItems) {
                    this.showNoItemsTimeout = setTimeout(function () {
                        _this2.setState({ showNoItems: false });
                    }, 10000);
                }
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.toggleNoComponentsMessage();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener("touchstart", this.handleTouchStart);
            window.addEventListener("touchend", this.handleTouchEnd);
            this.toggleNoComponentsMessage();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.showNoItemsTimeout);
            window.removeEventListener("touchstart", this.handleTouchStart);
            window.removeEventListener("touchend", this.handleTouchEnd);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var mobile = (0, _isMobile2.default)(this.context.screenSize);

            // const leftItem = (this.state.direction === 'right') ? this.state.previousItem : this.state.currentItem;
            // const rightItem = (this.state.direction === 'right') ? this.state.currentItem : this.state.previousItem;

            return _react2.default.createElement(
                Wrapper,
                null,
                this.state.hadItems && _react2.default.createElement(
                    CarouselComponent,
                    { visible: this.state.showNoItems },
                    _react2.default.createElement(
                        _grid2.default,
                        null,
                        _react2.default.createElement(
                            _row2.default,
                            null,
                            !mobile && _react2.default.createElement(
                                _column2.default,
                                { xs: 0, md: this.props.orientation === "vertical" ? 12 : 1, nogutter: true },
                                this.state.items && _react2.default.createElement(
                                    _container2.default,
                                    { fullSize: true, verticalAlignment: _alignments.Alignments.center, horizontalAlignment: _alignments.Alignments.center },
                                    _react2.default.createElement(
                                        CarouselButtonComponent,
                                        null,
                                        _react2.default.createElement(_carouselButton2.default, { size: _sizes.Sizes.xl, clickEvent: function clickEvent() {
                                                _this3.handleCarousel(_this3.props.orientation === "vertical" ? "up" : "left");
                                            },
                                            direction: '' + (this.props.orientation === "vertical" ? "up" : "left") })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                _column2.default,
                                { xs: 12, md: this.props.orientation === "vertical" ? 12 : 10, nogutter: true },
                                _react2.default.createElement(
                                    ItemsComponent,
                                    null,
                                    this.props.items && this.props.items.map(function (item, index) {
                                        return _react2.default.createElement(
                                            ItemComponent,
                                            { key: 'item-' + item.key, index: index, visible: index === _this3.state.currentItem },
                                            item
                                        );
                                    }),
                                    _react2.default.createElement(
                                        NoItemsComponent,
                                        { visible: (this.props.items === null || this.props.items.length === 0) && this.state.hadItems === true },
                                        _react2.default.createElement(
                                            _container2.default,
                                            { verticalAlignment: _alignments.Alignments.center, horizontalAlignment: _alignments.Alignments.center },
                                            _react2.default.createElement(
                                                NoItemsContentComponent,
                                                null,
                                                _react2.default.createElement(_header2.default, {
                                                    size: _sizes.Sizes.md,
                                                    top: _sizes.Sizes.none,
                                                    bottom: _sizes.Sizes.none,
                                                    text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Carousel.noItemsHeader' })
                                                }),
                                                _react2.default.createElement(_label2.default, {
                                                    size: _sizes.Sizes.md,
                                                    top: _sizes.Sizes.none,
                                                    bottom: _sizes.Sizes.none,
                                                    text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Carousel.noItemsLabel' })
                                                })
                                            )
                                        )
                                    )
                                )
                            ),
                            !mobile && _react2.default.createElement(
                                _column2.default,
                                { xs: 0, md: this.props.orientation === "vertical" ? 12 : 1, nogutter: true },
                                this.state.items && _react2.default.createElement(
                                    _container2.default,
                                    { fullSize: true, verticalAlignment: _alignments.Alignments.center, horizontalAlignment: _alignments.Alignments.center },
                                    _react2.default.createElement(
                                        CarouselButtonComponent,
                                        null,
                                        _react2.default.createElement(_carouselButton2.default, { size: _sizes.Sizes.xl, clickEvent: function clickEvent() {
                                                _this3.handleCarousel(_this3.props.orientation === "vertical" ? "down" : "right");
                                            },
                                            direction: '' + (this.props.orientation === "vertical" ? "down" : "right") })
                                    )
                                )
                            )
                        )
                    ),
                    this.props.orientation === "horizontal" && !mobile && this.state.items && _react2.default.createElement(
                        _grid2.default,
                        null,
                        _react2.default.createElement(
                            _row2.default,
                            { nogutter: true },
                            _react2.default.createElement(
                                _column2.default,
                                { xs: 12 },
                                _react2.default.createElement(
                                    _container2.default,
                                    { top: _sizes.Sizes.xs, verticalAlignment: _alignments.Alignments.center, horizontalAlignment: _alignments.Alignments.center },
                                    _react2.default.createElement(_label2.default, { text: this.state.currentItem + 1 + ' / ' + (this.props.items && this.props.items.length || 0),
                                        top: _sizes.Sizes.none,
                                        bottom: _sizes.Sizes.none,
                                        size: _sizes.Sizes.sm })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Carousel;
}(_react2.default.Component);

Carousel.contextTypes = {
    screenSize: _propTypes2.default.string
};

exports.default = Carousel;